const Styles = {
  buttonStyle: {
    backgroundColor: '#00ADF8',
    // borderRadius: 8,
    width: 417,
    height: 50,
  },

  divContainer: {
    marginTop: '40px',
    padding: '0px 20px 0px 48px',
  },

  typographyHeading: {
    fontSize: '32px',
    color: '#001A72',
    fontWeight: '700',
    // marginBottom: '4rem',
  },

  typographyMessage: {
    fontSize: '14px',
    fontWeight: '400',
    marginTop: '40px',
    marginBottom: '1rem',
    letterSpacing: '-0.02em',
    color: 'var(--gray-g-100, #8F92A1)',
  },

  fieldStyle: {
    width: '70%',
    border: '1px solid #EDEBEB',
    background: '#F2F2F2',
    borderRadius: '4px',
    marginBottom: '20px',
  },

  typographyFooter: {
    fontSize: 14,
    fontWeight: 500,
    color: '#0F59C4',
    marginTop: '45px',
    textDecoration: 'none',
    textAlign: 'center',
    marginRight: '7%',
  },

  errorMessage: {
    color: 'red',
    marginTop: 10,
  },

  paperStyle: {
    height: '100%',
    width: '60%',
    marginBottom: '40px',
    backgroundColor: '#F2F3F4',
    borderRadius: '0px 18px 18px 0px',
    borderRight: ' 29px solid #14645d',
    marginTop: '40px',
    opacity: 0.95,
  },

  // change password screen

  changePasswordPaper: {
    height: '580px',
    width: '570px',
    marginBottom: '4rem',
    backgroundColor: '#F2F3F4',
    borderRadius: '0px 18px 18px 0px',
    borderRight: '29px solid #14645d',
    opacity: 0.95,
  },

  cardContainer: {
    marginLeft: '4.1rem',
    marginTop: 42,
  },

  cardStyle: {
    // height: '580px',
    width: '533px',
    // marginBottom: '4rem',
    position: 'relative',
    background: '#14645d',
    borderRadius: '18px 0px 0px 18px',
    border: '0px solid #00449E',
    opacity: 0.95,
  },

  cardHeadingTypography: {
    fontSize: 28,
    fontWeight: 400,
    color: '#FFFFFF',
    maxWidth: '246px',
  },

  cardMessageTypography: {
    fontSize: 16,
    color: '#FFFFFF',
    marginBottom: 20,
    maxWidth: '360px',
  },

  instructionStyle: {
    fontSize: 16,
    color: '#FFFFFF',
    marginTop: 15,
    marginLeft: 38,
  },

  label: {
    display: 'block',
  },

  inputStyle: {
    height: 40,
    background: '#F2F2F2',
    width: '412px',
    fontSize: 16,
    color: '#00000',
    marginBottom: '4rem',
  },

  labelRequired: {
    color: 'red',
  },

  labelStyle: {
    fontSize: 12,
    color: ' #8F92A1',
    fontWeight: 700,
    marginBottom: '10px',
  },
};

export default Styles;
